import React, {useState} from 'react';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';

import {Container, Content, HelpArticleList} from './styles';

import {useNavigation} from '@react-navigation/native';

interface SearchArticle {
  id: string;
  text: string;
  data: {
    title: string;
    text: string;
  };
}

import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {HelpArticleItem} from '../../../components/shared/HelpArticleItem';
import {NotFound} from '../../../components/Interface/Search/NotFound';
import {SearchInput} from '../../../components/Interface/Forms/Inputs/SearchInput';
import {RFValue} from 'react-native-responsive-fontsize';

export function HowTo() {
  const navigation = useNavigation();

  const [filteredArticles, setFilteredArticles] = useState<SearchArticle[]>(
    [] as SearchArticle[],
  );
  const [searchTerm, setSearchTerm] = useState('');

  const articleData: SearchArticle[] = [
    {
      id: '1',
      text: 'Como funciona o clube de vantagens?',
      data: {
        title: 'Como funciona o clube de vantagens?',
        text: 'O Clube de vantagens proporciona economia ou benefícios ao usuário em produtos e serviços. São milhares de estabelecimentos credenciados, lojas físicas, comércios online e serviços em geral. \n\nA MasterClin está presente em todas as regiões do Brasil, contamos com mais de 10 mil estabelecimentos tanto físico quanto online. Você pode aproveitar de onde estiver, basta acessar nossa lista de parceiros dentro do app Baratão.',
      },
    },
    {
      id: '2',
      text: 'Quais são as vantagens disponíveis?',
      data: {
        title: 'Quais são as vantagens disponíveis?',
        text: 'As vantagens são disponibilizadas por cada loja com promoções únicas que podem durar por tempo limitado. \n\nVocê pode aproveitar descontos em academias, descontos em lojas online, facilidade no aluguel de veículos, ingressos para lazer, maior acessibilidade em cursos de graduação e diversos programas de serviços.',
      },
    },
    {
      id: '3',
      text: 'Como faço para me inscrever no clube de vantagens?',
      data: {
        title: 'Como faço para me inscrever no clube de vantagens?',
        text: 'Todos os usuários do Baratão possuem acesso ao clube de vantagens.',
      },
    },
    {
      id: '4',
      text: 'Como resgatar as vantagens?',
      data: {
        title: 'Como resgato as vantagens?',
        text: 'Navegue para a página principal do app Baratão, clique em clube de vantagens, escolha a loja ou estabelecimento que deseja usar seus benefícios, cada instituição tem benefícios diferentes, siga as orientações para utilizar seus benefícios naquela loja.',
      },
    },
    {
      id: '5',
      text: 'Quem pode usar os benefícios?',
      data: {
        title: 'Quem pode usar os benefícios?',
        text: 'Os benefícios oferecidos podem ser usados por toda a família, além do titular da conta, cônjuge, filhos, pais e avós podem receber benefícios como dependentes.',
      },
    },
    {
      id: '6',
      text: 'Quais são as regras de uso?',
      data: {
        title: 'Quais são as regras de uso?',
        text: 'Cada parceiro da MasterClin tem suas próprias regra de utilização, acesse o estabelecimento que deseja no app e confira.',
      },
    },
  ];

  function handleHelpArticle(title: string, text: string) {
    navigation.navigate('HelpArticle', {
      data: {
        text,
        title,
      },
    });
  }

  function handleSearchArticles(text: string) {
    const filter = articleData.filter(
      (e: SearchArticle) =>
        e.text
          .toLowerCase()
          .normalize('NFD')
          .includes(text.toLowerCase().normalize('NFD')) ||
        e.data.text
          .toLowerCase()
          .normalize('NFD')
          .includes(text.toLowerCase().normalize('NFD')) ||
        e.data.title
          .toLowerCase()
          .normalize('NFD')
          .includes(text.toLowerCase().normalize('NFD')),
    );

    setFilteredArticles(filter);
    setSearchTerm(text);
  }

  return (
    <>
      <TouchableWithoutFeedback onPress={Keyboard.dismiss} accessible={false}>
        <Container>
          <Header icon="chevron-left" />
          <Content>
            <Titles
              title="Clube de vantagens"
              subtitle="Ganhe benefícios exclusivos com o clube de vantagens do Baratão."
            />
            <SearchInput
              placeholder="Digite sua dúvida aqui"
              value={searchTerm}
              onChangeText={text => handleSearchArticles(text)}
            />
            <HelpArticleList
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{paddingBottom: RFValue(20)}}>
              {!searchTerm ? (
                articleData.map((item, index) => (
                  <HelpArticleItem
                    key={item.id}
                    showBorder={index === 0 ? false : true}
                    text={item.text}
                    action={() =>
                      handleHelpArticle(item.data.title, item.data.text)
                    }
                  />
                ))
              ) : !filteredArticles.length ? (
                <NotFound />
              ) : (
                filteredArticles.map((item, index) => (
                  <HelpArticleItem
                    key={item.id}
                    showBorder={index === 0 ? false : true}
                    text={item.text}
                    action={() =>
                      handleHelpArticle(item.data.title, item.data.text)
                    }
                  />
                ))
              )}
            </HelpArticleList>
          </Content>

          {/* <Footer>
            <FooterTitle>Alguma dúvida específica?</FooterTitle>
            <Button
              enabled
              title="Falar com atendente"
              onPress={() => navigation.navigate('Chat')}
            />
          </Footer> */}
        </Container>
      </TouchableWithoutFeedback>
    </>
  );
}
